// Mapped by closest pixel size: tiny=14px, small=16px, medium=18px, default=20px, large=24px,
// xlarge=32px
// Avatar: tiny=12px, mini=16px, small=20px, base=24px, medium=32px, large=40px
const ICON_SIZE_TO_AVATAR_SIZE = {
    tiny: 'tiny', // 14px → 12px
    small: 'mini', // 16px → 16px (exact)
    medium: 'small', // 18px → 20px
    default: 'small', // 20px → 20px (exact)
    large: 'base', // 24px → 24px (exact)
    xlarge: 'medium', // 32px → 32px (exact)
};
export const getAvatarSizeForIconSize = (size) => ICON_SIZE_TO_AVATAR_SIZE[size];
//# sourceMappingURL=getAvatarSizeForIconSize.js.map